import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root: {
        height: "100vh"
    },
    wrapButton:{
        display:"flex",
        justifyContent:"center",
        paddingBottom:"90px",
        marginTop:"50px"
    },
    wrapHeader:{
        display:"flex",
        paddingTop:"90px",
        justifyContent: "center",
        marginBottom: "20px"
    },
    wrapAvatar:{
        display:"flex",
        alignItems:"center",
        justifyContent: "center",
    },
    header_text: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        display: 'block',
        "& h2": {
            marginBottom: "0",
            fontSize: '1.9rem',
            marginTop: '0'
        },
        '& p': {
            fontSize: '1rem'
        }
    },
    header_text_mini: {
        [theme.breakpoints.down('xs')]: {
            display: 'block'
        },
        display: 'none',
        textAlign: 'center',
        "& h2": {
            marginBottom: "0",
            fontSize: '1.5rem',
            marginTop: '0'
        },
        '& p': {
            fontSize: '0.9rem'
        }
    },
    btnTokoSaya:{
        display:"flex",
        marginBottom:"40px",
        justifyContent: "center"
    },
    large: {
        width: 80,
        height: 80,
        border:"2px solid #5675D3"
      },
    content: {
        marginTop: "15px",
        width: "100%",
        position: "relative"
    },
    bantuanButton: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        display:"block",
        justifyContent: "center",
        marginTop: "10px",
        marginLeft: '10px',
        marginRight: '10px',
        '& button': {
            width: '100%'
        }
    },
    bantuanButton_mini: {
        [theme.breakpoints.down('xs')]: {
            display: 'block'
        },
        display:"none",
        justifyContent: "center",
        marginTop: "10px",
        marginLeft: '10px',
        marginRight: '10px',
        '& button': {
            width: '100%'
        }
    },
    listText: {
        '& span': {
            fontSize: '0.9rem'
        }
    }
}))

export default useStyles
